import type {
  CuratedProductListResponseType,
  CuratedProductListParametersType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductCuratedList = <TData = CuratedProductListResponseType,>(
  params: CuratedProductListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.CuratedProducts,
      params,
    ],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `products/curated`,
        retailerId: options?.RetailerId,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
